<template>
  <div class="market-vc-index">
    <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch">
    </Search>
    <div class="fun-btn-box">
      <el-button type="primary" class="mr10" @click="onAdd">+ 创建商品</el-button>
      <auth-button auth="storedCard:mall:share:data:export">
        <el-button type="primary" class="fun-btn mr10" @click="()=>{exportCardDistributionDataDialog = true}"  >分销数据导出</el-button>
      </auth-button>
    </div>
    <Table
      ref="table"
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #skuId="{ row }">{{ row.skuId }}</template>
      <template #storedCardTemplateId="{ row }">{{ row.storedCardTemplateId }}</template>
      <template #storedCardTemplateName="{ row }">{{ row.storedCardTemplateName || '---' }}</template>
      <template #name="{ row }">{{ row.name }}</template>
      <template #picture="{ row }">
        <div class="receipt-img">
          <img v-if="row.picture" :src="row.picture" @click="previewImgKey = row.picture" alt="">
          <span v-else>---</span>
        </div>
      </template>
      <template #platformName="{ row }">{{ row.platformName }}</template>
      <template #quantity="{ row }">{{ row.quantity }}</template>
      <template #remainingQuantity="{ row }">{{ row.remainingQuantity }}</template>
      <template #source="{ row }">{{ row.source == 'Runtu' ? '闰土自制' : '券中台投放' }}</template>
      <template #salesTime="{ row }">{{ row.salesStartTime + '-' + row.salesEndTime }}</template>
      <template #effective="{ row }">
        <div>
          <span :class="`dot color${row.effective}`"></span>
          <span>{{ effectiveMap[row.effective] }}</span>
        </div>
      </template>
      <template #operation="{ scope }">
        <el-button type="text" @click="onDetail(scope.row)">查看详情</el-button>
        <el-button type="text" @click="onChangeEffective(scope.row)">{{ scope.row.effective ? '下架' : '上架' }}</el-button>
        <el-button type="text" @click="onAdd(scope.row)">编辑</el-button>
        <!-- <el-button v-if="scope.row.platform == 'WechatMiniapp'" type="text" @click="onDownCode(scope.row)">下载推广码</el-button> -->
      </template>
    </Table>
    <Dialog :maskClose="true" :dialogShow="!!previewImgKey" title="图片预览" @maskClick="() => {previewImgKey = ''}">
      <template>
        <div class="receipt-img-preview">
          <el-image :src="previewImgKey" alt="" fit="contain"/>
        </div>
      </template>
    </Dialog>
     <el-dialog v-if="exportCardDistributionDataDialog" :visible="exportCardDistributionDataDialog" title="分销数据导出" width="35%" :show-close="false">
      <el-form ref="exportCardDistributionDataFrom" :model="exportCardDistributionDataFrom" label-width="80px" >
        <el-form-item label="选择时间" prop="dataTime" >
          <el-date-picker
            v-model="exportCardDistributionDataFrom.dataTime"
            type="datetimerange"
            range-separator=""
            format="yyyy/MM/dd HH:mm:ss"
            value-format="timestamp"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="" prop="" >
          <span class="input-remark">（*未选时间导出全部数据）</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="exportCardDistributionDataCancel">取 消</el-button>
        <el-button type="primary" @click="exportCardDistributionDataSubmit" :loading="exportCardDistributionDataLoading">{{exportCardDistributionDataLoading?'导出中...':'确 定'}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import tableList from '@/mixins/tableList'
import { api_getValueCardStoreList, api_putValueCardProductStatusChange,api_getValueCardDistributionDataExport } from '@/api/valueCardStore'
import { api_getDownloadMiniCode } from '@/api/market'
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import Dialog from "@/components/Dialog/index";
import { downFile } from "@/utils";
export default {
  name: "mvcsIndex",
  mixins: [ tableList ],
  components: {
    Search,
    Table,
    Dialog,
    AuthButton
  },
  data() {
    return {
      renderData: [
        {
          label: "商品名称",
          placeholder: "请输入商品名称",
          type: "input",
          key: "name",
        },
        {
          label: "状态",
          placeholder: "请选择状态",
          type: "select",
          option: [
            {label: '上架中', value: '1'},
            {label: '已下架', value: '0'},
          ],
          key: "effective",
        },
        {
          label: "售卖时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "time",
          valueFormat: 'timestamp'
        },
        {
          label: "上架渠道",
          placeholder: "请选择上架渠道",
          type: "select",
          option: [
            {label: '微信小程序', value: 'WXStoredCard'},
            {label: '支付宝小程序', value: 'AliStoredCard'},
          ],
          key: "scene",
        },
      ],
      form: {},
      tableKey: false,
      exporLoading:false,
      exportCardDistributionDataDialog:false,
      exportCardDistributionDataFrom:{dataTime:[]},
      exportCardDistributionDataLoading:false,
      tableThData: [
        { prop: "skuId", label: "商品ID", minWidth: "80", },
        { prop: "storedCardTemplateId", label: "储值卡ID", minWidth: "80", },
        { prop: "storedCardTemplateName", label: "储值卡名称", minWidth: "120", },
        { prop: "name", label: "商品名称", minWidth: "120", },
        { prop: "picture", label: "图片", minWidth: "80", },
        { prop: "platformName", label: "上架渠道", minWidth: "100", },
        { prop: "quantity", label: "上架数量", minWidth: "80", },
        { prop: "remainingQuantity", label: "剩余数量", minWidth: "80", },
        { prop: "source", label: "数据来源", minWidth: "120", },
        { prop: "salesTime", label: "售卖时间", minWidth: "200", },
        { prop: "effective", label: "状态", minWidth: "80", },
        { prop: "operation", label: "操作", minWidth: "180",},
      ],
      effectiveMap: {
        '0': '已下架',
        '1': '上架中',
      },
      previewImgKey: '',
    };
  },
  created () {
  },
  methods: {
    // 获取表格列表数据
    async getList() {
      this.loading = true
      let params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      params.salesStartTime = this.form.time ? this.form.time[0] : ''
      params.salesEndTime = this.form.time ? this.form.time[1] : ''
      delete params.time
      const data = await api_getValueCardStoreList(params)
      console.log('data: ', data);
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
    },

    // 上下架
    onChangeEffective(row) {
      let msg = row.effective ? '确定下架？' : '确定上架？'
      this.$baseConfirm(
        msg,
        {
          title: '提示',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false,
          type: 'warning',
        },
        async () => {
          const res = await api_putValueCardProductStatusChange({
            skuId: row.skuId
          })
          this.$baseMessage('操作成功', 'success')
          this.getList()
        }
      )
    },

    // 下载推广码
    async onDownCode(row) {
      let loading = this.$baseLoading(6)
      try {
        const res = await api_getDownloadMiniCode({id: row.skuId})
        console.log('line:140 res: ', res);
        const url = window.URL.createObjectURL(new Blob([res.data]))
        let fileName = res.headers['content-disposition'].split('filename=')[1]
        fileName = decodeURI(fileName)
        const link = document.createElement('a')
        link.target = '_blank'
        link.href = url
        link.setAttribute('download', fileName)
        link.click()
      } catch (err) {
        this.$baseMessage('下载失败', 'error')
        console.log('err: ', err);
      }
      loading.close()
    },
     async exportCardDistributionDataSubmit(){
          this.exportCardDistributionDataLoading = true
          let [actionTimeFrom,actionTimeTo]  = this.exportCardDistributionDataFrom.dataTime?this.exportCardDistributionDataFrom.dataTime:[]
            let params = {
                actionTimeFrom,
                actionTimeTo
            }
            try {
              this.$router.push({query: params})
              let res = await api_getValueCardDistributionDataExport(params)
              downFile(res)
              this.exportCardDistributionDataDialog = false
              this.exportCardDistributionDataFrom = {
                dataTime:[]
              }
            } catch (error) {
              console.log(error)
            }
          this.exportCardDistributionDataLoading = false
    },
    exportCardDistributionDataCancel(){
      this.exportCardDistributionDataDialog = false
      this.exportCardDistributionDataFrom = {
        dataTime:[]
      }
    },

    // 创建/编辑
    onAdd(row) {
      let query = row.skuId ? '?skuId=' + row.skuId : ''
      this.$router.push("/valueCardStore/list/add"+query);
    },

    // 查看详情
    onDetail(row) {
      this.$router.push(`/valueCardStore/list/detail?skuId=${row.skuId}`);
    },
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.market-vc-index {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .fun-btn-box {
    margin-top: 20px;
  }

  .look-btn {
    font-size: 10px;
    color: #3775FF;
    margin-left: 5px;
  }

  .dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 3px;
    margin-right: 10px;

    &.color0 {
      background-color: #F74A4A;
    }
    &.color1 {
      background-color: #05c8af;
    }
    &.color2 {
      background-color: #ccc;
    }
  }

  .del {
    color: #F74A4A;
  }
  .receipt-img {
    img {
      width: 50px;
      height: 50px;
    }
  }
  .receipt-img-preview {
    text-align: center;
    padding: 20px 0;
    img {
      width: 300px;
      height: 300px;
    }
  }
  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
  }
  .dot-success{
    background: #05c8af;
  }

  .dot-clear {
    background: #F74A4A;
  }

  .dot-ing {
    background: #3775FF;
  }

  .dot-new {
    background: #ccc;
  }
}
</style>
